<template>
  <div>
    <Breadcrumb msg1="验配随访" msg2="OK镜/RGP验配" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="6">
          <el-select v-model="query.customer_id" filterable remote placeholder="按客户搜索" :remote-method="searchCustomer" clearable style="width: 100%">
            <el-option v-for="c in customerOptions" :key="c.id" :label="c.name + ' ' + c.phone" :value="c.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select v-model="query.lens_type" placeholder="镜片类型" clearable>
            <el-option label="OK镜" value="OK镜"></el-option>
            <el-option label="RGP" value="RGP"></el-option>
            <el-option label="框架" value="框架"></el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select v-model="query.status" placeholder="状态" clearable>
            <el-option label="验配中" value="验配中"></el-option>
            <el-option label="已完成" value="已完成"></el-option>
            <el-option label="已停用" value="已停用"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">新增</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="客户" width="100"><template slot-scope="scope">{{ customerName(scope.row.customerId) }}</template></el-table-column>
        <el-table-column label="类型" prop="lensType" width="90"></el-table-column>
        <el-table-column label="品牌" prop="brand" width="120"></el-table-column>
        <el-table-column label="型号" prop="model" width="120"></el-table-column>
        <el-table-column label="参数" prop="parameters" show-overflow-tooltip></el-table-column>
        <el-table-column label="验配日期" prop="fittingDate" width="110"></el-table-column>
        <el-table-column label="医生" width="100"><template slot-scope="scope">{{ doctorNameOf(scope.row.doctorId) }}</template></el-table-column>
        <el-table-column label="状态" prop="status" width="90"></el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="show" width="600px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px" v-if="show">
        <el-form-item label="客户" required>
          <el-select v-model="form.customer_id" filterable remote placeholder="输入姓名/手机号搜索" :remote-method="searchCustomer" style="width: 100%">
            <el-option v-for="c in customerOptions" :key="c.id" :label="c.name + ' ' + c.phone" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="镜片类型">
          <el-select v-model="form.lens_type" style="width: 100%">
            <el-option label="OK镜" value="OK镜"></el-option>
            <el-option label="RGP" value="RGP"></el-option>
            <el-option label="框架" value="框架"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌"><el-input v-model="form.brand"></el-input></el-form-item>
        <el-form-item label="型号"><el-input v-model="form.model"></el-input></el-form-item>
        <el-form-item label="验配日期"><el-date-picker v-model="form.fitting_date" type="date" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker></el-form-item>
        <el-form-item label="医生">
          <el-select v-model="form.doctor_id" style="width: 100%">
            <el-option v-for="doc in doctors" :key="doc.id" :label="doc.realname" :value="doc.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="参数"><el-input v-model="form.parameters" type="textarea" placeholder="如 OD: BC 8.6 / DIA 10.5；OS: ..."></el-input></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import { loadCustomerMap, customerName } from '@/utils/customerName'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, customer_id: null, lens_type: '', status: '' },
      list: [],
      total: 0,
      show: false,
      dialogTitle: '',
      form: {},
      customerOptions: [],
      doctors: []
    }
  },
  created () {
    this.getData()
    loadCustomerMap(this.$axios.http)
    this.$axios.http.get('/users/doctors').then(r => { if (r.data.status === 200) this.doctors = r.data.data || [] })
  },
  methods: {
    customerName,
    doctorNameOf (id) { const d = this.doctors.find(x => x.id === id); return d ? d.realname : '' },
    getData () {
      this.$axios.get('/lensFittings', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    searchCustomer (kw) {
      if (!kw) return
      this.$axios.http.get('/customers/select', { params: { keyword: kw } }).then(r => {
        if (r.data.status === 200) this.customerOptions = r.data.data || []
      })
    },
    add () {
      this.dialogTitle = '新增验配单'
      this.form = { customer_id: null, lens_type: 'OK镜', brand: '', model: '', parameters: '', fitting_date: '', doctor_id: null }
      this.show = true
    },
    edit (row) {
      this.dialogTitle = '编辑验配单'
      this.form = Object.assign({}, row, {
        customer_id: row.customerId,
        lens_type: row.lensType,
        brand: row.brand,
        model: row.model,
        parameters: row.parameters,
        fitting_date: row.fittingDate,
        doctor_id: row.doctorId
      })
      this.customerOptions = [{ id: row.customerId, name: customerName(row.customerId), phone: '' }]
      this.show = true
    },
    save () {
      if (!this.form.customer_id) { this.$message.warning('请选择客户'); return }
      if (this.form.id) {
        this.$axios.put(`/lensFittings/${this.form.id}`, () => { this.show = false; this.getData() }, this.form)
      } else {
        this.$axios.post('/lensFittings', () => { this.show = false; this.getData() }, this.form)
      }
    },
    del (id) {
      this.$axios.del(`/lensFittings/${id}`, () => this.getData())
    }
  }
}
</script>
